export const SENTRY_DSN =
  "https://594bd65affeceb7c298147c7d7bb3007@o4505946954268672.ingest.sentry.io/4505946956300288"
export const SENTRY_HOST = "o4505946954268672.ingest.sentry.io"
export const SENTRY_PROJECT_IDS = ["4505946956300288"]
